import { render } from "./ShoppingListSettings.vue?vue&type=template&id=39fd4c1f"
import script from "./ShoppingListSettings.vue?vue&type=script&lang=js"
export * from "./ShoppingListSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__